import subscriptionService from '../../../../services/subscription/SubscriptionService';

export function getSubscriptionData(organisationId) {
  return subscriptionService.findSubscriptionByOrganisation(organisationId)
    .then(currentSubscription => {
      if (currentSubscription) {
        const {planId, depositorServiceAuthorized, validUntil} = currentSubscription;
        return {
          planId,
          depositorServiceAuthorized,
          validUntil,
          remainingUserAccounts: (currentSubscription.maximumNumberOfUserAccounts - currentSubscription.numberOfUserAccounts)
        };
      }

      // No subscription found
      return undefined;
    });
}

export function getPlanData(organisationId) {
  return subscriptionService.getOrganisationPlan(organisationId);
}

export function getNumberOfActiveClients(organisation = {}) {
  const {organisationId, depositor} = organisation;
  if (!depositor) {
    return new Promise(resolve => resolve());
  }
  return subscriptionService.getNumberOfActiveClients(organisationId);
}
